<script>
    import {tick} from 'svelte';
    import {xml2json} from '../lib/xml2json.js';
    import Liquid from 'liquidjs';
    import AssessmentFinding from '../Assessments/AssessmentFinding.svelte';
    import Loader from '../Utilities/Loader.svelte';
    import {notifier} from '@beyonk/svelte-notifications';
    import {getObj, getObjects, saveObj, deleteObj} from '../lib/data.js';
    import {pop} from 'svelte-spa-router';


    export let params;

    let issues = [];
    let selected_issue;
    let loading = false;

    let showExtractions = true;
    let showTransform = true

    let transform;

    async function getTransform(id) {
        transform = await getObj("transform", id)
    }

    async function load() {
        let xml_string = await this.files[0].text();
        let xml;
        selected_issue = undefined;
        loading = true;

        console.log(loading);

        xml = (new DOMParser()).parseFromString(xml_string, "text/xml");

        if (xml.firstChild.nodeName == "issues") {
            issues = JSON.parse(xml2json(xml, ''))['issues']['issue'];
            console.log(issues);
        } else if (xml.firstChild.nodeName == "NessusClientData_v2") {
            let parsed_xml = JSON.parse(xml2json(xml, ''));
            issues = [];
            for (let host of parsed_xml['NessusClientData_v2']['Report']['ReportHost']) {
                let trimmed_host = JSON.parse(JSON.stringify(host));
                delete trimmed_host['ReportItem'];
                issues = issues.concat(host["ReportItem"].filter((i) => i['@severity'] != 0).map((item) => {
                    return {...item, host: trimmed_host}
                }));
            }
            console.log(issues);
        } else {
            issues = [];
            notifier.danger("Invalid File");
        }

        await tick();
        loading = false;
    }

    function selectIssue() {
        selected_issue = issues[this.dataset.idx];

        // trigger refresh
        transform = transform
    }

    function addExtraction() {
        transform.extractions = [...transform.extractions, {
            field: this.dataset.field,
            name: "",
            regex: ""
        }]
    }

    function removeExtraction() {
        let idx = this.dataset.idx;
        transform.extractions.splice(idx, 1);
        transform.extractions = transform.extractions;
    }

    function extractField(extract) {
        if (!selected_issue) return [];

        let field_value = selected_issue[extract.field];
        if (!field_value) return [];

        let re;

        if (!extract.regex) return [];

        try{
            re = new RegExp(extract.regex, 'g');
        } catch (err) {
            return [];
        }

        return [...field_value.matchAll(re)];
    }

    function addTransform() {
        transform.transforms = [...transform.transforms, {
            name: "",
            template: ""
        }]
    }

    async function saveTransform() {
        transform = await saveObj("transform", transform);
        notifier.success("Transform Saved");
        pop();
    }

    async function deleteTransform() {
        await deleteObj("transform", transform);
        notifier.success("Transform Deleted");
        pop();
    }

    function render_template(t) {
        if (!selected_issue) return "No Issue Selected";

        let issue = JSON.parse(JSON.stringify(selected_issue))

        for (let extract of transform.extractions) {
            issue[extract.name] = extractField(extract);
        }

        const engine = new Liquid.Liquid();
        try {
            return engine.parseAndRenderSync(t.template, issue);
        } catch (err) {
            return "Invalid Template: " + err.toString();
        }
    }

    $: getTransform(params.id);
</script>

<style>
    .preview {
        padding: 1.5em;
        width: 100%;
    }

    .columns {
        height: calc(100vh - 9.25rem);
    }

    .column {
        height: 100%;
        overflow: auto;
    }

    .file {
        width: 100%;
        overflow: hidden;
    }

    hr {
        background-color: #ccc;
    }

    hr:last-of-type {
        display: none;
    }

    .box {
        margin-bottom: 1.25rem;
    }
</style>


<div class="columns">
    <div class="column is-2 is-narrow">
        <div class="menu">
            <p class="menu-label">Load Issue Template</p>
            <div class="file">
                <input type="file" on:change={load}>
            </div>
            <p class="menu-label">Select Source Issue</p>
            <p>
            {#if loading}
                <Loader />
            {/if}
            </p>
            <ul class="menu-list">
                {#each issues as issue, idx}
                    <li><span class="link" on:click={selectIssue} data-idx={idx}>{issue.name || issue.plugin_name}</span> </li>
                {/each}
            </ul>
        </div>
    </div>
    <div class="column">
        <h2 class="title is-2">Issue Object</h2>
        {#if selected_issue}
            <AssessmentFinding finding={selected_issue} displayType="pre">
                <div slot="key" let:key>
                    <div><strong>{key}</strong></div>
                    <button class="button" data-field={key} on:click={addExtraction}>Add Extraction</button>
                </div>
            </AssessmentFinding>
        {/if}
    </div>
    <div class="column">
        {#if transform }
            <form on:submit={saveTransform}>
                <h2 class="title is-2">
                    Transform
                    <div class="buttons is-pulled-right">
                        {#if transform.id}
                        <span class="button is-danger" on:click={deleteTransform}>Delete</span>
                        {/if}
                        <button class="button is-success">Save</button>
                    </div>
                </h2>
                <div class="field">
                    <label class="label">Transform Name</label>
                    <div class="control">
                        <input class="input" type="text" bind:value={transform.name} required>
                    </div>
                </div>
                <label class="checkbox">
                <input type="checkbox" bind:checked={transform.combine}>
                    Combine Issues
                </label>
            </form>
            <h3 class="title is-3 pointer" on:click={()=> showExtractions = !showExtractions }>
                <i class="icon fas" class:fa-caret-down={showExtractions} class:fa-caret-right={!showExtractions}></i>
                Extractions
            </h3>
            {#if showExtractions}
            <div class="box">
                {#each transform.extractions as extract, idx}
                    <div class="field is-horizontal">
                        <div class="field-label">Source Field</div>
                        <div class="field-body">
                            <div class="field">
                                <p class="control">
                                    {extract.field}
                                    <i class="icon is-pulled-right fas fa-trash pointer" data-idx={idx} on:click={removeExtraction}></i>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label">Extract Field Name</div>
                        <div class="field-body">
                            <div class="field">
                                <p class="control">
                                    <input type="text" class="input" bind:value={extract.name}>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Regex</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <textarea class="textarea" bind:value={extract.regex}></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label">Results</div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control content">
                                    <ul>
                                        {#each extractField(extract) as matches, idx}
                                            <li>
                                                Match {idx+1}
                                                <ul>
                                                    {#each matches as match}
                                                        <li>{match}</li>
                                                    {/each}
                                                    <hr>
                                                </ul>
                                            </li>
                                        {/each}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                {/each}
            </div>
            {/if}
            <h3 class="title is-3">
                <span class="pointer" on:click={() => showTransform = !showTransform}>
                    <i class="icon fas" class:fa-caret-down={showTransform} class:fa-caret-right={!showTransform}></i>
                    Transform
                </span>
                <i class="is-pulled-right fas fa-plus pointer" on:click={addTransform}></i>
            </h3>
            {#if showTransform}
                {#each transform.transforms as t}
                <div class="box">
                    <div class="field is-horizontal">
                        <div class="field-label">Field Name</div>
                        <div class="field-body">
                            <div class="field">
                                <p class="control">
                                    <input type="text" class="input" bind:value={t.name}>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label is-normal">
                            <label class="label">Template</label>
                        </div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control">
                                    <textarea class="textarea" bind:value={t.template}></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field is-horizontal">
                        <div class="field-label">Results</div>
                        <div class="field-body">
                            <div class="field">
                                <div class="control preview">
                                        {@html render_template(t)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/each}
        {/if}
    {:else}
        <Loader />
    {/if}
    </div>
</div>